import Vue from 'vue'
import VueRouter from 'vue-router'
//import lanhu_zhuce from '../views/lanhu_zhuce/index.vue'
import index from '../views/index/index.vue'
import lanhu_lvjing from '../views/lanhu_lvjing/index.vue'
import lanhu_xunibeijing from '../views/lanhu_xunibeijing/index.vue'
//import lanhu_dengluerweima from '../views/lanhu_dengluerweima/index.vue'
// import lanhu_mianshizhongzhi from '../views/lanhu_interview/lanhu_mianshizhongzhi/index.vue'
// import lanhu_kaishimianshi from '../views/lanhu_kaishimianshi/index.vue'
import lanhu_yonghufankui from '../views/lanhu_yonghufankui/index.vue'
import lanhu_mianshilishishanchu from '../views/lanhu_mianshilishishanchu/index.vue'
import interview_mianshilishi from '../views/interview_mianshilishi/index.vue'
import lanhu_mianshilishibianji from '../views/lanhu_mianshilishibianji/index.vue'
import lanhu_dengluzhanghaomima from '../views/lanhu_dengluzhanghaomima/index.vue'
import lanhu_shouye2 from '../views/lanhu_shouye2/index.vue'
import lanhu_mianshilishichongxinmingmingbianji from '../views/lanhu_mianshilishichongxinmingmingbianji/index.vue'
//import lanhu_dengluwangjimima from '../views/lanhu_dengluwangjimima/index.vue'
import interview_xuanzeshuziren from '../views/interview_xuanzeshuziren/index.vue'
import lanhu_shouye1 from '../views/lanhu_shouye1/index.vue'
import lanhu_meiyan from '../views/lanhu_meiyan/index.vue'
import lanhu_yonghufankuibianji from '../views/lanhu_yonghufankuibianji/index.vue'
import lanhu_dengluduanxindenglu from '../views/lanhu_dengluduanxindenglu/index.vue'
import lanhu_mianshijiexi from '../views/lanhu_mianshijiexi/index.vue'
import lanhu_shouyewodejiaohu from '../views/lanhu_shouyewodejiaohu/index.vue'
import lanhu_shouyedanchuang from '../views/lanhu_shouyedanchuang/index.vue'
import lanhu_gerenzhongxin from '../views/lanhu_gerenzhongxin/index.vue'
import lanhu_houxuanrenmianshixiangqing from '../views/lanhu_houxuanrenmianshixiangqing/index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/lanhu_houxuanrenmianshixiangqing',
    name: 'lanhu_houxuanrenmianshixiangqing',
    component: lanhu_houxuanrenmianshixiangqing
  },
  {
    path: '/chating',
    name: 'chating',
   component: () => import('../views/chating/index.vue'),
  },
  {
    path: '/',
    name: 'index',
    component: () => import('../views/index/index.vue'),
  },
  {
    path: '/qzpp',
    name: 'qzpp',
    component: () => import('../views/qzpp/index.vue'),
  },
  {
    path: '/404',
    component: () => import('../views/404.vue'),
  },
  {
    path: '/store',
    component: () => import('../views/store.vue'),
    // redirect: "store/entry",
    redirect: "store/dashboard",
    children: [
      {
        path: 'entry',
        component: () => import('../views/entry/index.vue'),
        redirect: "entry/loginEmail",
        children: [
          {
            path: 'loginEmail',
            component: () => import('../views/entry/loginEmail/index.vue'),
          },
          {
            path: 'loginPwd',
            component: () => import('../views/entry/loginPwd/index.vue'),
          },
          {
            path: 'loginQRCode',
            component: () => import('../views/entry/loginQRCode/index.vue'),
          },
          {
            path: 'forgottenPwd',
            component: () => import('../views/entry/forgottenPwd/index.vue'),
          }
        ]
      },
      {
        path: 'dashboard',
        component: () => import('../views/dashboard/index.vue'),
        redirect: "dashboard/profile",
        children: [
          {
            path: 'profile',
            component: () => import('../views/dashboard/profile/index.vue'),
          },
          {
            path: 'QRCode',
            component: () => import('../views/dashboard/QRCode/index.vue'),
          },
          {
            path: 'phone',
            component: () => import('../views/dashboard/phone/index.vue'),
          },
          {
            path: 'password',
            component: () => import('../views/dashboard/password/index.vue'),
          },
        ]
      },
      {
        path: '/Interview_Analysis/:id',
        name: 'Interview_Analysis',
        component: () => import('@/views/Interview_Analysis/index.vue')
      },

      {
        path: 'interview_ing',
        component: () => import('../views/interview_ing/index.vue')
      },
      {
        path: 'interview_pre',
        component: () => import('../views/interview_pre/index.vue')
      },
      {
        path: 'select_metahuman',
        component: interview_xuanzeshuziren
      },
      {
        path: 'Interview_Analysis',
        component: () => import('../views/Interview_Analysis/index.vue'),
      },
    ]
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('../views/dashboard/index.vue'),
  },
  {
    path: '/Interview_Analysis',
    name: 'Interview_Analysis',
    component: () => import('../views/Interview_Analysis/index.vue'),
  },
  {
    path: '/lanhu_lvjing',
    name: 'lanhu_lvjing',
    component: lanhu_lvjing
  },
  {
    path: '/lanhu_xunibeijing',
    name: 'lanhu_xunibeijing',
    component: lanhu_xunibeijing
  },
  // {
  //   path: '/lanhu_dengluerweima',
  //   name: 'lanhu_dengluerweima',
  //   component: lanhu_dengluerweima
  // },
  {
    path: '/interview',
    name: 'interview',
    component: () => import('../views/lanhu_interview/index.vue'),
    redirect: '/interview/start',
    children: [
      {
        path: 'start',
        component: () => import('../views/lanhu_interview/lanhu_kaishimianshi/index.vue'),
      },
      {
        path: 'end',
        component: () => import('../views/lanhu_interview/lanhu_mianshizhongzhi/index.vue'),
      }
    ]
  },
  {
    path: '/interview_ing',
    name: 'interview_ing',
    component: () => import('../views/interview_ing/index.vue')
  },
  {
    path: '/interview_pre',
    name: 'interview_pre',
    component: () => import('../views/interview_pre/index.vue')
  },
  // {
  //   path: '/lanhu_mianshizhongzhi',
  //   name: 'lanhu_mianshizhongzhi',
  //   component: lanhu_mianshizhongzhi
  // },
  // {
  //   path: '/lanhu_kaishimianshi',
  //   name: 'lanhu_kaishimianshi',
  //   component: lanhu_kaishimianshi
  // },
  {
    path: '/lanhu_yonghufankui',
    name: 'lanhu_yonghufankui',
    component: lanhu_yonghufankui
  },
  {
    path: '/lanhu_mianshilishishanchu',
    name: 'lanhu_mianshilishishanchu',
    component: lanhu_mianshilishishanchu
  },
  {
    path: '/interview_mianshilishi',
    name: 'interview_mianshilishi',
    component: interview_mianshilishi
  },
  {
    path: '/lanhu_mianshilishibianji',
    name: 'lanhu_mianshilishibianji',
    component: lanhu_mianshilishibianji
  },
  {
    path: '/lanhu_dengluzhanghaomima',
    name: 'lanhu_dengluzhanghaomima',
    component: lanhu_dengluzhanghaomima
  },
  {
    path: '/lanhu_shouye2',
    name: 'lanhu_shouye2',
    component: lanhu_shouye2
  },
  {
    path: '/lanhu_mianshilishichongxinmingmingbianji',
    name: 'lanhu_mianshilishichongxinmingmingbianji',
    component: lanhu_mianshilishichongxinmingmingbianji
  },
  // {
  //   path: '/lanhu_dengluwangjimima',
  //   name: 'lanhu_dengluwangjimima',
  //   component: lanhu_dengluwangjimima
  // },
  {
    path: '/interview_xuanzeshuziren',
    name: 'interview_xuanzeshuziren',
    component: interview_xuanzeshuziren
  },
  {
    path: '/lanhu_shouye1',
    name: 'lanhu_shouye1',
    component: lanhu_shouye1
  },
  {
    path: '/lanhu_meiyan',
    name: 'lanhu_meiyan',
    component: lanhu_meiyan
  },
  {
    path: '/lanhu_yonghufankuibianji',
    name: 'lanhu_yonghufankuibianji',
    component: lanhu_yonghufankuibianji
  },
  {
    path: '/lanhu_dengluduanxindenglu',
    name: 'lanhu_dengluduanxindenglu',
    component: lanhu_dengluduanxindenglu
  },
  {
    path: '/lanhu_mianshijiexi',
    name: 'lanhu_mianshijiexi',
    component: lanhu_mianshijiexi
  },
  {
    path: '/lanhu_shouyewodejiaohu',
    name: 'lanhu_shouyewodejiaohu',
    component: lanhu_shouyewodejiaohu
  },
  {
    path: '/lanhu_shouyedanchuang',
    name: 'lanhu_shouyedanchuang',
    component: lanhu_shouyedanchuang
  },
  {
    path: '/lanhu_gerenzhongxin',
    name: 'lanhu_gerenzhongxin',
    component: lanhu_gerenzhongxin
  },
  // 404 page must be placed at the end !!!
  { path: '*', redirect: '/404' }
]

const router = new VueRouter({
  mode: 'history',
  // base: process.env.BASE_URL,
  base: process.env.NODE_ENV === 'production' ? '' : '/',
  routes
})

export default router
